interface KeyboardShortcutsModalProps {
  onClose: () => void
}

const SHORTCUTS = [
  { group: 'История', items: [
    { keys: ['Ctrl', 'Z'], desc: 'Отменить действие' },
    { keys: ['Ctrl', 'Y'], desc: 'Повторить действие' },
  ]},
  { group: 'Блок', items: [
    { keys: ['Ctrl', 'C'], desc: 'Копировать выбранный блок' },
    { keys: ['Ctrl', 'V'], desc: 'Вставить блок' },
    { keys: ['Del'], desc: 'Удалить выбранный блок' },
    { keys: ['↑', '↓'], desc: 'Переместить блок вверх / вниз' },
    { keys: ['Esc'], desc: 'Снять выделение' },
  ]},
  { group: 'Масштаб', items: [
    { keys: ['Ctrl', '+'], desc: 'Увеличить' },
    { keys: ['Ctrl', '-'], desc: 'Уменьшить' },
    { keys: ['Ctrl', '0'], desc: 'Сбросить к 100%' },
  ]},
  { group: 'Интерфейс', items: [
    { keys: ['Ctrl', "'"], desc: 'Показать/скрыть сетку' },
    { keys: ['?'], desc: 'Показать горячие клавиши' },
    { keys: ['G'], desc: 'Переключить редактирование' },
  ]},
]

function Key({ label }: { label: string }) {
  return (
    <kbd style={{
      display: 'inline-block',
      padding: '2px 7px',
      background: '#f3f4f6',
      border: '1px solid #d1d5db',
      borderBottom: '3px solid #9ca3af',
      borderRadius: '5px',
      fontSize: '11px',
      fontFamily: 'monospace',
      fontWeight: 700,
      color: '#374151',
      lineHeight: '18px',
      whiteSpace: 'nowrap',
    }}>{label}</kbd>
  )
}

export function KeyboardShortcutsModal({ onClose }: KeyboardShortcutsModalProps) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div style={{ background: 'var(--bg-1)', borderRadius: '16px', width: '540px', maxWidth: '100%', maxHeight: '80vh', overflow: 'auto', boxShadow: '0 24px 64px rgba(0,0,0,0.25)' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: 'var(--bg-1)', zIndex: 1 }}>
          <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 800, color: 'var(--text-primary)' }}>Горячие клавиши</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', color: 'var(--text-muted)', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '16px 24px' }}>
          {SHORTCUTS.map(group => (
            <div key={group.group} style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '10px', fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '8px' }}>{group.group}</div>
              {group.items.map(item => (
                <div key={item.desc} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ fontSize: '13px', color: 'var(--text-primary)' }}>{item.desc}</span>
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexShrink: 0 }}>
                    {item.keys.map((k, i) => (
                      <span key={k} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {i > 0 && <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>+</span>}
                        <Key label={k} />
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div style={{ padding: '12px 24px', borderTop: '1px solid var(--border)', fontSize: '12px', color: 'var(--text-muted)', textAlign: 'center' }}>
          Нажмите <Key label="?" /> чтобы открыть этот список снова
        </div>
      </div>
    </div>
  )
}
